module.exports = __webpack_public_path__ + "static/drzwi-premium-wew-6a7b4fb82e2c2d9ba2da8da96fbcecd8.png";